var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[(!_vm.userRelated)?_c('NavBar'):_c('DashboardNav'),_c('RouterView'),_c('FooterArea')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }